import axios from "axios";
import axiosRetry from "axios-retry";
import { setupAuthInterceptor } from "./setupAuthInterceptor";
import { BASE_URL_REKOGNITION } from "../constants";

const apiRekognition = axios.create({
	baseURL: BASE_URL_REKOGNITION,
});

// Configure axios-retry
axiosRetry(apiRekognition, {
	retries: 5, // Number of retries
	retryDelay: axiosRetry.exponentialDelay, // Use exponential backoff
	// attach callback to each retry to handle logging or tracking
	// @ts-expect-error
	onRetry: (err) => console.log(`Retrying request: ${err.message}`),
	// Specify conditions to retry on, this is the default
	// which will retry on network errors or idempotent requests (5xx)
	retryCondition: (error) => axiosRetry.isNetworkOrIdempotentRequestError(error),
});

setupAuthInterceptor(apiRekognition);

export default apiRekognition;
